export var Mode;
(function (Mode) {
    Mode["Light"] = "light";
    Mode["Dark"] = "dark";
})(Mode || (Mode = {}));
var isKnownMode = function (mode) {
    return Object.keys(Mode).filter(function (key) { return Mode[key] === mode; }).length >= 1;
};
var getClassNameByMode = function (mode) {
    return isKnownMode(mode) ? "awsui-polaris-" + mode + "-mode" : null;
};
var notAwsModeClass = function (className) {
    return !/awsui-(.*)-mode/.test(className);
};
export var applyMode = function (mode, target) {
    if (target === void 0) { target = document.body; }
    if (!isKnownMode(mode)) {
        mode && console.warn("Mode " + mode + " is not supported");
        return;
    }
    var modeClassName = getClassNameByMode(mode);
    var classes = target.className
        .split(' ')
        .map(function (className) { return className.trim(); })
        .filter(notAwsModeClass);
    modeClassName && classes.push(modeClassName);
    target.className = classes.join(' ');
};
//# sourceMappingURL=index.js.map